import Key from "../clientVariables.json";

export const msalInstance = {
  auth: {
    clientId: Key.azure_appId,
    redirectUri: Key.azure_redirectUri,
    authority: Key.azure_authority,
  },
  cache: {
    cacheLocation: "localStorage", // or "sessionStorage"
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read", "Mail.Read", "Mail.Send", "Calendars.ReadWrite"], // Add required scopes
};
